/** @jsx jsx */

import { css, jsx } from '@emotion/core';
import { Spinner } from '@zapier/design-system';

const preloaderCss = css`
  margin: 100px auto;
  display: flex;
  justify-content: center;
`;

const PreloadPage = () => {
  return (
    <div css={preloaderCss}>
      <Spinner size="large" />
    </div>
  );
};

export default PreloadPage;
